export enum RadarDetectionEndpointType {
  HTTP = 'HTTP',
  RPC = 'RPC',
  MESSAGING = 'MESSAGING'
}
